import { AREA_CODES, ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';
import { removeCountryCodeFromPhone } from './removeCountryCodeFromPhone';

export const formatPhoneByCountryCode = (phone: string, leadCountryCode: ECountryCode, storeCountryCode: ECountryCode) => {

    const countryCodeToUse = AREA_CODES?.[leadCountryCode]?.code || AREA_CODES?.[storeCountryCode]?.code || AREA_CODES.MX.code;
    return countryCodeToUse + removeCountryCodeFromPhone(phone);
}